import { MachineServices } from 'common/bento/types/MachineConfig';
import { apolloClient } from 'common/graphql/clients';

import { SubmitMandatedCapitalDepositForAccountHolderDocument } from '../graphql/mutations/submitMandatedCapitalDepositForAccountHolder.gql';
import { Model } from './model';

export enum Service {
  SubmitApplication = 'submitApplication',
}

const services: MachineServices<Model, Service> = {
  submitApplication: ({ getModuleData }) => {
    const { companyProfileId } = getModuleData().data.viewer.company;

    /**
     * Note that this service won’t be called if we enter the legacy plans pages,
     * as these pages call submit themselves. This is a fallback for cases when
     * the account holder submits while having already paid the capital deposit
     * (which shouldn’t happen if there’s no error as they occur consecutively).
     */
    return apolloClient.mutate({
      mutation: SubmitMandatedCapitalDepositForAccountHolderDocument,
      variables: { input: { companyProfileId } },
    });
  },
};

export default services;
